import * as yup from "yup";

export const validationSchema = (max: number) =>
  yup.object({
    amount: yup
      .number()
      .max(max, `Max Amount ${max}$`)
      .required("Amount is Required"),
  });
